import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React__default from 'react';
import classNames from 'classnames';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import Checkbox from '../Checkbox/bbb86efee75a495b2eb803aad8b5e8c05236c93f8c0727ac51f1a82b7608b17b.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';

var AdvancedTableCheckbox = function AdvancedTableCheckbox(_ref) {
  var state = _ref.state,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onFocus = _ref.onFocus,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'cell' : _ref$variant,
    isRowFocused = _ref.isRowFocused;
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var labels = {
    "true": translate('checked'),
    "false": translate('unchecked'),
    mixed: translate('mixed')
  };
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: classNames(styles.advancedTableCheckbox, _defineProperty({}, styles.header, variant === 'header')),
    "aria-live": isRowFocused ? 'polite' : undefined,
    "aria-relevant": "text"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.hiddenLiveRegion
  }, labels[state]), /*#__PURE__*/React__default.createElement("div", {
    className: styles.checkboxContainer
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    className: styles.checkbox,
    "aria-hidden": true,
    checked: state === 'true',
    onChange: function onChange() {
      /* noop (supresses React input warning since we use the cell onClick for a larger click target instead of this onChange) */
    },
    inputProps: {
      'aria-checked': state,
      tabIndex: -1,
      onFocus: onFocus
    }
  }), state === 'mixed' && /*#__PURE__*/React__default.createElement("div", {
    className: styles.mixed
  })));
};

export { AdvancedTableCheckbox as default };
